var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRmisActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37824 25.0764C12.1762 21.3844 16.8394 11.3561 30 2.625C19.4301 4.27143 10.9845 15.0481 9.01554 17.7422C7.04663 15.098 3.16062 12.2541 0 11.855C2.07254 13.4017 6.04663 19.3188 9.37824 25.0764Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6528 0C13.6528 0 17.0103 4.25079 25.5232 3.88658C15.9377 8.0326 9.05691 17.7116 9.05691 17.7116C5.86002 13.83 2.56468 12.5129 1.10354 12.0838C0.994733 9.33727 1.19681 6.58698 1.70458 3.88159C10.2745 4.27574 13.6528 0 13.6528 0Z",
    fill: "url(#paint0_radial_1909_113770)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.979 2.64062C28.5075 4.14362 27.2005 5.7888 26.0775 7.54999C27.1409 18.6859 22.9959 26.1696 13.6422 30.0013C5.89742 26.8282 1.73032 21.1318 1.13965 12.9134C3.73032 15.6075 6.06711 19.1499 9.39353 25.0321C15.3728 14.8292 22.7562 7.06604 29.979 2.64062Z",
    fill: "url(#paint1_radial_1909_113770)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7359 7.34434L25.6633 7.4541V7.58382C25.767 8.68643 25.824 9.77407 25.824 10.8068C25.824 14.888 25.0053 18.4303 23.3991 21.339C23.1232 21.828 22.8278 22.3019 22.5131 22.7609C20.6063 20.2688 18.5286 17.9027 16.2955 15.6763C19.561 11.5178 23.3952 7.80334 27.6944 4.63521C27.1089 5.37361 26.425 6.28663 25.7359 7.34434ZM10.7981 10.6522C11.5442 11.2808 12.2696 11.9107 12.9742 12.5431C15.6374 9.79902 19.3991 6.51613 23.8136 4.271C17.7152 4.10136 14.6426 1.59679 13.653 0.583984C12.5804 1.6866 9.15557 4.47056 2.15039 4.27598C5.17112 6.22177 8.05972 8.35091 10.7981 10.6522Z",
    fill: "url(#paint2_linear_1909_113770)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1909_113770",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.90665 -1.04773) scale(14.1295 13.6055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#62B91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7226"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1909_113770",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8599 15.2433) scale(12.1865 11.7346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959EA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#42515F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1909_113770",
    x1: 8.44314,
    y1: -1.78339,
    x2: 27.4758,
    y2: 17.9823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmisActive);
export default __webpack_public_path__ + "static/media/rmisActive.ed0e8a376be3114daa9e03c098d64b5a.svg";
export { ForwardRef as ReactComponent };